import { upperCase } from "lodash-es";

import { UserShirtSize, UserBooleanAttribute } from "Bands/types";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { userBodyPreferences } = copy;

export const fields: IFormFields = [
  {
    name: "bodyPreferences.smoker",
    label: userBodyPreferences.fields.smoker,
    type: IFieldType.radioGroup,
    options: [
      {
        label: "Yes",
        value: UserBooleanAttribute.yes,
      },
      {
        label: "No",
        value: UserBooleanAttribute.no,
      },
    ],
    style: {
      gridColumn: "span 2",
    },
  },
  {
    name: "bodyPreferences.shirtSize",
    label: userBodyPreferences.fields.shirtSize.title,
    placeholder: userBodyPreferences.fields.shirtSize.placeholder,
    type: IFieldType.select,
    options: (Object.keys(UserShirtSize) as Array<keyof typeof UserShirtSize>).map(key => ({
      value: UserShirtSize[key],
      label: upperCase(UserShirtSize[key]),
    })),
  },
  {
    name: "bodyPreferences.shoeSize",
    label: userBodyPreferences.fields.shoeSize,
    type: IFieldType.text,
  },
  {
    name: "bodyPreferences.allergies",
    label: userBodyPreferences.fields.allergies,
    type: IFieldType.rte,
    size: "s",
  },
  {
    name: "bodyPreferences.dietaryRequirements",
    label: userBodyPreferences.fields.dietaryRequirements,
    type: IFieldType.rte,
    size: "s",
  },
  {
    name: "bodyPreferences.otherImportantInformation",
    label: userBodyPreferences.fields.otherImportantInformation,
    type: IFieldType.rte,
    size: "s",
    style: {
      gridColumn: "span 2",
    },
  },
];
